import React from 'react';
import { Box, Typography, Card } from '@mui/material';
import './LiveEvent.css';

/**
 * LiveEvent Component
 * Displays the latest event from any camera with image and details
 */
const LiveEvent = ({ event, imagePath }) => {
    if (!event) {
        return (
            <Box sx={{ backgroundColor: '#1976d2', color: 'white', padding: '50px', borderRadius: '10px', minHeight: '150px', textAlign: 'center' }}>
                <Typography variant="h6">Čekanje na događaje...</Typography>
            </Box>
        );
    }

    const isANPR = event.type === 'ANPR' || event.event_type === 'ANPR';
    const isHeartbeat = event.type === 'heartBeat' || event.type === 'heartbeat';

    return (
        <Box className="split-layout">
            {/* Left: Camera Image (1/3) */}
            <Box className="split-left">
                <Box className="camera-snapshot">
                    {imagePath ? (
                        <img
                            src={`${process.env.REACT_APP_API_URL}/${imagePath}`}
                            alt="Camera snapshot"
                            className="camera-image"
                        />
                    ) : (
                        <Box className="camera-placeholder">
                            <Typography variant="h1">📷</Typography>
                            <Typography>Slika nije dostupna</Typography>
                        </Box>
                    )}
                </Box>
            </Box>

            {/* Right: Event Details (2/3) */}
            <Box className="split-right">
                <Box className="live-event">
                    {isANPR && (
                        <Box className="event-content">
                            <Box className="event-header">
                                <Typography className="event-type">🚗 ANPR Događaj</Typography>
                                <Box className="event-time">
                                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                        📷 Kamera: {event.event_time || event.timestamp || 'N/A'}
                                    </Typography>
                                    <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                        🖥️ Server: {event.server_time || new Date().toLocaleString('sr-RS')}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className="event-details">
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Registarska tablica</Typography>
                                    <Typography className="event-detail-value">{event.plate || 'N/A'}</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Kamera</Typography>
                                    <Typography className="event-detail-value">{event.camera_id || event.ip || 'N/A'}</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Pravac</Typography>
                                    <Typography className="event-detail-value">{event.direction || 'N/A'}</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Pouzdanost</Typography>
                                    <Typography className="event-detail-value">{event.confidence || 0}%</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Tip vozila</Typography>
                                    <Typography className="event-detail-value">{event.vehicle?.type || 'N/A'}</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Boja vozila</Typography>
                                    <Typography className="event-detail-value">{event.vehicle?.color || 'N/A'}</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Brzina</Typography>
                                    <Typography className="event-detail-value">{event.vehicle?.speed || 0} km/h</Typography>
                                </Box>
                            </Box>
                        </Box>
                    )}

                    {isHeartbeat && (
                        <Box className="event-content">
                            <Box className="event-header">
                                <Typography className="event-type">💓 Heartbeat</Typography>
                                <Typography className="event-time">
                                    {event.timestamp || new Date().toLocaleString('sr-RS')}
                                </Typography>
                            </Box>
                            <Box className="event-details">
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">Status</Typography>
                                    <Typography className="event-detail-value">Kamera aktivna</Typography>
                                </Box>
                                <Box className="event-detail">
                                    <Typography className="event-detail-label">IP adresa</Typography>
                                    <Typography className="event-detail-value">{event.ip || 'N/A'}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default LiveEvent;
